import { TextLink } from '@oneaudi/unified-web-components';
import { useCallback } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { useMarketConfig } from '~/app/market-config';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction } from '~/app/tracking/feld-m-types';
import { useIframeDialog } from '~/components/dialog/iframe-dialog/iframe-dialog';

export const OmnibusDialog = () => {
	const { i18n } = useI18n();
	const { config } = useMarketConfig();
	const { showIframeDialog } = useIframeDialog();

	const onClickHandler = useCallback(() => {
		config.useIframe
			? showIframeDialog({ url: config.omnibus.url, name: 'static-tacticals-layer' })
			: window.open(config.omnibus.url);

		appTrackingService.summaryClickEvent({
			eventAction: EventAction.InternalLink,
			eventName: `configurator (configuration overview) - click to open static tacticals layer`,
			componentName: 'configurator-configuration-overview',
			label: i18n('ngc.summary.omnibus.trigger'),
			targetURL: config.omnibus.url,
		});

		appTrackingService.viewChangeEvent({
			eventName: 'configurator - static tacticals layer',
			componentName: 'static-tacticals-layer',
		});
	}, [config.omnibus.url, config.useIframe, i18n, showIframeDialog]);

	return (
		<TextLink onClick={onClickHandler} variant={'inline'} icon={'info-circle'} size={'sm'}>
			{i18n('ngc.summary.omnibus.trigger')}
		</TextLink>
	);
};
